import React from 'react';

import './Form.module.css';

const Radio = ({ children, ...props }) => {
  return (
    <label styleName="radio-container">
      {children}
      <input type="radio" {...props} />
      <span styleName="dot" />
    </label>
  );
};

export default Radio;
